<template>
  <div class="modal-card addUser">
    <div class="modal-card-head">
      <p class="modal-card-title">Create Questionnaire</p>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">
          <h2>Current period: {{ currentPeriod.Name }}</h2>
          <p>This allows you to add questionnaires to countries that do not have a questionnaire for the current period.</p>
          <div v-if="countries.length < 1">
            <b>Currently every country has a questionnaire for the current period.</b>
          </div>
          <div v-if="countries.length > 0">
            <div class="breathe-sm">
              <b>Select a Country</b>
              <b-select placeholder="Select the Country" expanded v-model="selectedCountry">
                <option v-for="option in countries"
                        :value="option.Id"
                        :key="option.Id">
                  {{ option.Name }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button class="yellow-button" @click="$parent.close()">Cancel</b-button>
      <b-button class="is-primary" @click="addQuestionnaire">Submit</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selectedCountry: "",
        countries: [],
        currentPeriod: ''
      }
    },
    computed: {

    },
    methods: {
      async addQuestionnaire() {
        if (this.selectedCountry) {
          await this.$http.post("api/questionnaire/addQuestionnaire/" + this.selectedCountry)
            .then(resp => {
              if (resp.data) {
                this.$buefy.notification.open({ message: "Questionnaire Created.", type: "is-success" });
                this.$parent.close();
              }
              else {
                this.$buefy.notification.open({ message: "An unhandled exception occured.", type: "is-danger" });
              }
            })
        }
        else {
          this.$buefy.notification.open({ message: "Please select a Country that needs a questionnaire.", type: "is-danger" });
        };
      },
    },
    async created() {
      await this.$http.get("api/questionnaire/needQuestionnaire")
        .then(resp => {
          this.countries = resp.data;
        }).catch(err => {
          console.error(err);
        });

      await this.$http.get("api/period/currentPeriod")
        .then(resp => {
          this.currentPeriod = resp.data;
        }).catch(err => {
          console.error(err);
        });
    }
  }
</script>
